import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeletePricingPlanAdjustmentFormModal from 'src/features/pricingPlan/components/form/adjustments/DeletePricingPlanAdjustmentFormModal';
import UpdatePricingPlanAdjustmentFormModal from 'src/features/pricingPlan/components/form/adjustments/UpdatePricingPlanAdjustmentFormModal';
import { PricingPlanPeriodAdjustment } from 'src/features/pricingPlan/utils/types';
import { pricingPlanMessages } from 'src/features/pricingPlan/utils/messages';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellAdjustmentActions({ row }: CellContext<PricingPlanPeriodAdjustment, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdatePricingPlanAdjustmentFormModal
                        selectedAdjustment={row.original}
                        semantics={{ entryName: formatMessage(pricingPlanMessages.adjustment).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdatePricingPlanAdjustmentFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeletePricingPlanAdjustmentFormModal selectedAdjustment={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeletePricingPlanAdjustmentFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
